import { EventEmitter } from "events";
import Dispatcher from "../Dispatcher";
import actionTypes from "../actions/ActionTypes";
const CHANGE_EVENT = "defaultChange";
let _lastChange = "";
let _currentDefault = void 0;
let _defaults = void 0;
let _deleteResult = void 0;
let _defaultsByBP = [];
let _defaultDetails = [];
class DefaultStore extends EventEmitter {
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  }
  emitChange() {
    this.emit(CHANGE_EVENT);
  }
  getDefaults() {
    return _defaults;
  }
  getDefault() {
    return _currentDefault;
  }
  getLastAction() {
    return _lastChange;
  }
  getDeleteResult() {
    return _deleteResult;
  }
  getDefaultsByBP() {
    return _defaultsByBP;
  }
  getDefaultDetails() {
    return _defaultDetails;
  }
}
const store = new DefaultStore();
Dispatcher.register((action) => {
  _lastChange = action.actionType;
  switch (action.actionType) {
    case actionTypes.GetDefaults:
      _defaults = action.Result;
      store.emitChange();
      break;
    case actionTypes.GetDefault:
      _currentDefault = action.Result;
      store.emitChange();
      break;
    case actionTypes.DefaultUpdate:
      _currentDefault = action.Result;
      store.emitChange();
      break;
    case actionTypes.DefaultSaveAs:
      if (action.Result.resultMessage === "Success") {
        console.log("update Store");
        console.log(action.Result.result);
        _currentDefault = action.Result.result;
      }
      store.emitChange();
      break;
    case actionTypes.DefaultDelete:
      let delDefault = _defaults.find((d) => d.defaultsDBId === action.Result.deleteId);
      if (delDefault) {
        let idx = _defaults.indexOf(delDefault);
        let newDefaults = [..._defaults];
        newDefaults.splice(idx, 1);
        _defaults = newDefaults;
      }
      _deleteResult = action.Result;
      store.emitChange();
      break;
    case actionTypes.GetDefaultsByBP:
      console.log("store");
      _defaultsByBP = action.Result;
      store.emitChange();
      break;
    case actionTypes.DefaultGetDetails:
      _defaultDetails = action.Result;
      store.emitChange();
      break;
    default:
  }
});
export default store;
